export default "/**\n * Behavior: Casts a wave of fire.\n */\n\n// Pull in module dependencies.\nconst Fire = require(\"fire\");\n\nFire.wave();\n";